import { EMPTY_COMPANY_PREFERENCES } from '../types';

export const DEFAULT_PREFERENCE_LANGUAGE = 'en';

export function companyPreferencesQueryKey(companyId) {
  return ['company-preferences', companyId];
}

export function isBlank(value) {
  if (value == null) return true;
  return String(value).trim() === '';
}

/**
 * @param {unknown} raw
 * @returns {import('../types').CompanyPreferences}
 */
export function normalizeCompanyPreferences(raw) {
  if (!raw || typeof raw !== 'object') {
    return { ...EMPTY_COMPANY_PREFERENCES };
  }

  return {
    country: raw.country == null ? '' : String(raw.country).trim(),
    currency: raw.currency == null ? '' : String(raw.currency).trim(),
    language: raw.language == null ? '' : String(raw.language).trim(),
  };
}

/**
 * Country and currency must both be present. Language is not part of completeness.
 *
 * @param {unknown} prefs
 */
export function isPreferencesComplete(prefs) {
  const normalized = normalizeCompanyPreferences(prefs);
  return !isBlank(normalized.country) && !isBlank(normalized.currency);
}

/**
 * @param {Partial<import('../types').CompanyPreferences>} [fields]
 * @returns {import('../types').CompanyPreferences}
 */
export function buildPreferencesPayload({
  country = '',
  currency = '',
  language = '',
} = {}) {
  const normalized = normalizeCompanyPreferences({
    country,
    currency,
    language,
  });

  return {
    country: normalized.country,
    currency: normalized.currency,
    language: isBlank(normalized.language)
      ? DEFAULT_PREFERENCE_LANGUAGE
      : normalized.language,
  };
}
